import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const emptyForm = { code: '', category: '', name: '', description: '', unit: 'Adet', is_assembly: true };

export default function Assemblies() {
  const [assemblies, setAssemblies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);

  const fetchAssemblies = async () => {
    const res = await api.get('/api/bom/assemblies');
    setAssemblies(res.data);
  };

  const fetchCategories = async () => {
    const res = await api.get('/api/products/categories');
    setCategories(res.data);
  };

  useEffect(() => {
    fetchAssemblies();
    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/products/', form);
      setShowForm(false);
      setForm(emptyForm);
      fetchAssemblies();
      fetchCategories();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Montajlar (BOM)</h2>
        <button onClick={() => { setForm(emptyForm); setShowForm(true); }} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium text-sm">
          + Yeni Montaj
        </button>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg max-h-screen overflow-y-auto">
            <h3 className="text-lg font-bold mb-4">Yeni Montaj</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Kod *</label>
                  <input required value={form.code} onChange={e => setForm({...form, code: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Kategori *</label>
                  <input required value={form.category} onChange={e => setForm({...form, category: e.target.value})} list="categories-list" className="w-full border rounded px-3 py-2" placeholder="Yazın veya seçin" />
                  <datalist id="categories-list">
                    {categories.map(c => <option key={c} value={c} />)}
                  </datalist>
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ad *</label>
                  <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Açıklama</label>
                  <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="w-full border rounded px-3 py-2" rows={2} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Birim</label>
                  <select value={form.unit} onChange={e => setForm({...form, unit: e.target.value})} className="w-full border rounded px-3 py-2">
                    {['Adet', 'Set', 'Paket', 'Kutu'].map(u => <option key={u} value={u}>{u}</option>)}
                  </select>
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button type="submit" className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-medium">Kaydet</button>
                <button type="button" onClick={() => setShowForm(false)} className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 font-medium">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Kod</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Kategori</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Ad</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Birim</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {assemblies.map(a => (
              <tr key={a.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-sm font-mono text-gray-600">{a.code}</td>
                <td className="px-4 py-3"><span className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded">{a.category}</span></td>
                <td className="px-4 py-3 font-medium text-gray-800">{a.name}</td>
                <td className="px-4 py-3 text-gray-600">{a.unit}</td>
                <td className="px-4 py-3 text-right">
                  <Link to={`/assemblies/${a.id}`} className="text-blue-600 hover:text-blue-800 font-medium text-sm">Detay / BOM</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {assemblies.length === 0 && (
          <div className="text-center py-12 text-gray-400">Henüz montaj eklenmemiş</div>
        )}
      </div>
    </div>
  );
}
